import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyCSPYs5ymziTlkpkf5oFrUaTgUlfKAlVnk",
  authDomain: "agenda-online-67d7c.firebaseapp.com",
  projectId: "agenda-online-67d7c",
  storageBucket: "agenda-online-67d7c.appspot.com",
  messagingSenderId: "552682603484",
  appId: "1:552682603484:web:65fce078ad7f2363200519",
  measurementId: "G-V1T6DP1FRC"
};

const firebaseapp = initializeApp(firebaseConfig)

const db = getFirestore(firebaseapp);
const auth = getAuth(firebaseapp);

export { db, auth };